/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The request body for exporting letters
 */
export type ExportLettersRequest = {
    /**
     * Family grouped by
     */
    group?: ExportLettersRequest.group;
    /**
     * Custom letter template
     */
    customize_letter_field?: string;
    /**
     * The order by field
     */
    order_by?: string;
    /**
     * The all selected field
     */
    allSelected?: boolean;
    /**
     * The filters
     */
    filters?: {
        /**
         * Archived exists filter
         */
        'archived:exists'?: boolean;
        /**
         * Email default filter
         */
        'or:emailDefault'?: string;
        /**
         * Phone default filter
         */
        'or:phoneDefault'?: string;
    };
};

export namespace ExportLettersRequest {

    /**
     * Family grouped by
     */
    export enum group {
        INDIVIDUALS = 'individuals',
        ENTIRE_FAMILY = 'entire_family',
        LIST_FAMILY = 'list_family',
    }


}

